import * as Yup from "yup";

import { variables } from "../../Variables";

const { required } = variables;

export const requestToSchema = Yup.object({
  main_type: Yup.string().required(required),
  sub_type: Yup.string().required(required),
  request_type: Yup.string().required(required),
  receiver_id: Yup.number().required(required),
  quantity: Yup.number().required(required).min(1),
  delivery_date: Yup.string().required(required),
  // note: Yup.string().required(required),
});
